import { Box, Grid, IconButton, Tooltip } from '@mui/material';
import CloseIcon from 'assets/img/icons/CloseIcon';
import { toggleNavbar } from 'core/store/navbarSlice';
import LogoWithLink from 'pages/PlaygroundV2Page/components/LogoWithLink';
import { useDispatch } from 'react-redux';

const SmallScreenNavHeader = () => {
  const dispatch = useDispatch();
  return (
    <Box
      sx={{
        margin: { mobile: '8px 16px 0px 0px', tablet: '8px 8px 0px 0px' },
        justifyContent: 'space-between',
        alignItems: 'center',
        display: 'flex',
        direction: 'column',
        width: '100%',
      }}
    >
      <Grid item>
        <Tooltip title="Visit factiverse.ai" arrow>
          <LogoWithLink width={'210'} height={'65'} />
        </Tooltip>
      </Grid>
      <IconButton
        onClick={() => dispatch(toggleNavbar())}
        sx={{
          p: 1.5,
          zIndex: 2200,
        }}
      >
        <CloseIcon data-testid="CloseIcon" />
      </IconButton>
    </Box>
  );
};

export default SmallScreenNavHeader;
